import React from 'react';

import {
  ArrowLeft,
  Breakpoints,
  CloseButton,
  Container,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
  ThemeProvider,
} from '@vw-marketing/us-components';

import {  StyledLayerHeader, StyledLeftArrowCTA } from './styles';

interface LayerContentWrapperProps {
  title: React.ReactNode;
  onClose: () => void;
  children: React.ReactNode;
  hideCloseButton?: boolean;
  onGoBack?: () => void;
}

export const LayerContentWrapper = ({ title, onClose, children, hideCloseButton, onGoBack }: LayerContentWrapperProps) => (
  <ThemeProvider theme="main">
    <Container
      padding={{
        top: {
          [Breakpoints.default]: "static350",
          [Breakpoints.b560]: "static450",
        },
        bottom: {
          [Breakpoints.default]: "static350",
          [Breakpoints.b560]: "static450",
        },
        right: {
          [Breakpoints.default]: "static350",
          [Breakpoints.b560]: "static450",
          [Breakpoints.b1280]: "static520",
        },
        left: {
          [Breakpoints.default]: "static350",
          [Breakpoints.b560]: "static450",
          [Breakpoints.b1280]: "static520",
        },
      }}
      wrap="always"
    >
      <StyledLayerHeader hasGoBack={!!onGoBack}>
        {onGoBack && (
          <StyledLeftArrowCTA tag="button" emphasis="tertiary" icon={<ArrowLeft variant="default" />} onClick={onGoBack} />
        )}
        <TextCustom
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize20,
              fontWeight: TextWeight.bold,
              color: TextColor.primary,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
          }}
        >
          {title}
        </TextCustom>
        {!hideCloseButton && !onGoBack && <CloseButton ariaLabel='close' onClick={onClose} />}
      </StyledLayerHeader>
      {children}
    </Container>
  </ThemeProvider>
);
